define.alias("ember-functions-as-helper-polyfill/initializers/install-function-helper-manager", "media/initializers/install-function-helper-manager");